const HowLabReferWorksDialog: React.FC<{ closeMe: () => void }> = ({ closeMe }) => {
    return (
        <div className="modal">
            <div onClick={closeMe} className="modal-overlay"></div>
            <div className="modal-content flex flex-col w-40p min-h-1/3">
                <div className="flex items-center justify-between px-16 py-12 border-b border-darwin-neutral-100">
                    <p className="text-darwin-neutral-1000 text-14 font-700">How does it work?</p>
                    <div
                        onClick={closeMe}
                        className="flex items-center justify-center w-16 h-16 cursor-pointer"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                            className="w-16 h-16 fill-darwin-neutral-1000"
                        >
                            <path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"></path>
                        </svg>
                    </div>
                </div>
                <div className="flex-1 flex items-start w-full p-20">
                    <div className="w-50p space-y-32 pr-28">
                        <div className="flex items-baseline space-x-8">
                            <div className="min-w-6 min-h-6 bg-darwin-neutral-500 rounded-full"></div>
                            <p className="text-darwin-neutral-700 text-14">
                                When you forward an investigation list to partner labs, they receive
                                the tests you've prescribed to the patient.
                            </p>
                        </div>
                        <div className="flex items-baseline space-x-8">
                            <div className="min-w-6 min-h-6 bg-darwin-neutral-500 rounded-full"></div>
                            <p className="text-darwin-neutral-700 text-14">
                                The partner lab can then reach out to the patient and assist them in
                                getting those investigations done.
                            </p>
                        </div>
                    </div>
                    <div className="w-50p">
                        <div className="w-full bg-darwin-accent-dark-blue-800 rounded-8 p-16">
                            <img src="/images/lab-referral.png" className="w-full" />
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-end px-16 py-12 border-t border-darwin-neutral-100">
                    <button onClick={closeMe} className="primary-btn px-14 py-8 btn--small">
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HowLabReferWorksDialog;
